/*
 * @Author: your name
 * @Date: 2022-03-26 20:28:00
 * @LastEditTime: 2022-04-10 10:04:32
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \lampl-react\src\components\Search\style.ts
 */

import styled from "@emotion/styled";
import search from "assets/search.svg";

export const Container = styled.span`
  position: relative;
  display: inline-block;
  direction: ltr;
  margin-right: 16px;

  @media (max-width: 599px) {
    margin-right: 8px;
  }

  input {
    position: relative;
    vertical-align: top;
    width: 100%;
    appearance: none;
    background: rgba(30, 41, 59, 0.6);
    border: 1px solid rgba(148, 163, 184, 0.2);
    border-radius: 10px;
    color: #f1f5f9;
    font-size: 14px;
    font-weight: 400;
    font-family: inherit;
    padding: 9px 14px 9px 38px;
    background-image: url(${search});
    background-size: 16px 16px;
    background-repeat: no-repeat;
    background-position-y: center;
    background-position-x: 14px;
    -webkit-appearance: none;
    outline: none;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);

    &::placeholder {
      color: rgba(203, 213, 225, 0.5);
    }

    @media (max-width: 768px) {
      padding: 8px 12px 8px 36px;
      background-position-x: 12px;
      font-size: 13px;
    }
  }

  input:focus {
    background: rgba(30, 41, 59, 0.8);
    border-color: rgba(139, 92, 246, 0.5);
    box-shadow:
      0 0 0 3px rgba(139, 92, 246, 0.15),
      inset 0 1px 2px rgba(0, 0, 0, 0.1);
    background-image: url(${search});
    background-size: 16px 16px;
    background-repeat: no-repeat;
    background-position-y: center;
    background-position-x: 14px;
    -webkit-appearance: none;

    @media (max-width: 768px) {
      background-position-x: 12px;
    }
  }

  input:hover:not(:focus) {
    background: rgba(30, 41, 59, 0.7);
    border-color: rgba(148, 163, 184, 0.3);
  }
`;

export const SearchView = styled.div`
  position: absolute;
  z-index: 999;
  top: 40px;
  right: 0;
  border-radius: 14px;
  margin: 8px 0 0;
  padding: 0;
  height: auto;
  background: transparent;
  border: none;
  max-width: 500px;
  min-width: 400px;
  box-shadow:
    0 20px 50px rgba(0, 0, 0, 0.5),
    0 0 0 1px rgba(148, 163, 184, 0.1);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);

  @media (max-width: 768px) {
    min-width: 320px;
    max-width: 90vw;
  }

  &::before {
    content: "";
    position: absolute;
    top: -7px;
    right: 32px;
    display: block;
    border-top: 7px solid transparent;
    border-bottom: 7px solid rgba(15, 23, 42, 0.95);
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    height: 0;
    width: 0;
    filter: drop-shadow(0 -2px 4px rgba(0, 0, 0, 0.2));
  }

  .search_header {
    background: linear-gradient(
      135deg,
      rgba(15, 23, 42, 0.95) 0%,
      rgba(30, 41, 59, 0.95) 100%
    );
    padding: 14px 18px;
    border-top-left-radius: 14px;
    border-top-right-radius: 14px;
    font-weight: 600;
    font-size: 13px;
    color: #cbd5e1;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    border-bottom: 1px solid rgba(148, 163, 184, 0.15);
  }

  .search_body {
    background: linear-gradient(
      135deg,
      rgba(15, 23, 42, 0.95) 0%,
      rgba(30, 41, 59, 0.95) 100%
    );
    color: #f1f5f9;
    border-bottom-left-radius: 14px;
    border-bottom-right-radius: 14px;
    max-height: 400px;
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-track {
      background: rgba(30, 41, 59, 0.5);
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(148, 163, 184, 0.3);
      border-radius: 3px;

      &:hover {
        background: rgba(148, 163, 184, 0.5);
      }
    }

    li {
      padding: 13px 18px;
      cursor: pointer;
      transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
      font-size: 14px;
      border-bottom: 1px solid rgba(148, 163, 184, 0.08);
      position: relative;

      &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 0;
        background: linear-gradient(
          90deg,
          rgba(139, 92, 246, 0.6),
          rgba(59, 130, 246, 0.4)
        );
        transition: width 0.2s ease;
      }
    }

    li:last-child {
      border-bottom: none;
      border-bottom-left-radius: 14px;
      border-bottom-right-radius: 14px;
    }

    li:hover {
      background: linear-gradient(
        90deg,
        rgba(139, 92, 246, 0.15) 0%,
        rgba(59, 130, 246, 0.1) 100%
      );
      color: #e0e7ff;
      padding-left: 22px;

      &::before {
        width: 3px;
      }
    }
  }
`;
